import Swal from 'sweetalert2';

const showError = (text, icon = 'error') => {
  Swal.fire({
    text,
    icon,
  });
};

export const showErrorHtml = (html, icon = 'error') => {
  Swal.fire({
    html,
    icon,
  });
};

export default showError;
